module.exports = {
      id: "toast-info-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-58d03b3f1466f1d475a0d37264fe8fc2.svg#toast-info",
      toString: function () {
        return this.url;
      }
    }